/** "€1.50" in the visitor's language. */
export const money = (cents, currency = 'eur', lang = 'en') =>
  new Intl.NumberFormat(lang, { style: 'currency', currency: currency.toUpperCase(), maximumFractionDigits: cents % 100 ? 2 : 0 }).format(
    cents / 100,
  )
